package com.shakster.gifcreator.worker

import com.varabyte.kobweb.worker.Attachments
import com.varabyte.kobweb.worker.WorkerContext
import org.w3c.dom.Worker
import kotlin.js.Json
import kotlin.js.json

class GifWorker(override var onOutput: WorkerContext.(output: com.shakster.gifcreator.worker.GifWorkerOutput) -> Unit = {}) :
    com.varabyte.kobweb.worker.Worker<com.shakster.gifcreator.worker.GifWorkerInput, com.shakster.gifcreator.worker.GifWorkerOutput> {

    private val ioSerializer = com.shakster.gifcreator.worker.GifWorkerFactory().createIOSerializer()

    private val worker = Worker("/_kobweb/workers/com-shakster-gifcreator/gif-worker.js").apply {
        onmessage = { e ->
            val json = e.data.unsafeCast<Json>()
            val outputDeserialized = try {
                ioSerializer.deserializeOutput(json["_output"] as String)
            } catch (e: Throwable) {
                console.warn(buildString {
                    append("Unable to deserialize output generated by worker, ignoring it.")
                    e.message?.let { append("\nException: $it") }
                })
                null
            }
            if (outputDeserialized != null) {
                val ctx = WorkerContext(Attachments.fromJson(json))
                ctx.onOutput(outputDeserialized)
            }
        }
    }

    override fun postInput(input: com.shakster.gifcreator.worker.GifWorkerInput, attachments: Attachments) {
        val inputSerialized = try {
            ioSerializer.serializeInput(input)
        } catch (e: Throwable) {
            console.warn(buildString {
                append("Unable to serialize argument when calling `GifWorker.postInput(com.shakster.gifcreator.worker.GifWorkerInput)`, ignoring the call.")
                e.message?.let { append("\nException: $it") }
            })
            null
        }
        if (inputSerialized != null) {
            worker.postMessage(
                json("_input" to inputSerialized).add(attachments.toJson()),
                attachments.toValues()
            )
        }
    }

    override fun terminate() {
        worker.terminate()
    }
}